import React from "react";

import * as StateLib from "@/Utils/StateLib";
import { GetFieldDefsFromList } from "@/Utils/DataLib";
import { GetFieldLabelFromFieldName } from "@/appComponents/Blocks/Composites/CompositeChartSearch/AdvancedSearchModal";
import ColumnDisplayFieldToggleMenu from "./ColumnDisplayFieldToggleMenu";
import { filterInternalFields } from "@/Utils/FilterInternalFields";

const ColumnDisplayMenu = props => {
  const { searchState, setSearchState, searchCtrl, showAllFieldNames } = props;

  const ToggleField = target => {
    let columnNames = searchState.columnNames;
    let wsMgr = StateLib.GetWSMgr();
    let org = wsMgr.GetAccountName();
    let doc = StateLib.GetDoc();
    let chartID = doc.GetChartID();
    let newColumnList = columnNames ? GetColumnNames(columnNames.slice(0)) : [];
    let targetField = target.value;
    let targetIdx = newColumnList.indexOf(targetField);
    const eventTracker = wsMgr.GetUsageTracker();
    var state = null;

    if (targetIdx > -1) newColumnList.splice(targetIdx, 1);
    else newColumnList.push(targetField);

    let cacheColumns = {};
    if (localStorage.directoryColumnFields)
      cacheColumns = JSON.parse(localStorage.directoryColumnFields);
    cacheColumns[org + "_" + chartID] = newColumnList;
    localStorage.directoryColumnFields = JSON.stringify(cacheColumns);

    setSearchState(prevState => {
      if (newColumnList.length > prevState.columnNames.length) {
        state = "enabled";
        searchCtrl.current?.DoSearch({ projectFields: newColumnList });
      } else {
        state = "disabled";
      }
      eventTracker.ReportEvent("directory_mode.column_field.saved", {
        field: targetField,
        enabled: state === "enabled"
      });
      return {
        ...prevState,
        columnNames: newColumnList
      };
    });
  };

  const GetColumnNames = fields => {
    let defaultFieldDefs = GetFieldDefsFromList(fields);
    return defaultFieldDefs.map(item => {
      return item.GetFieldName();
    });
  };

  let selectedFieldNames = GetColumnNames(searchState.columnNames);
  const fieldNames = (() => {
    let workingFieldNames = [];
    const doc = StateLib.GetDoc();

    if (showAllFieldNames) {
      const fields = doc?.GetFieldList2(true, false, false, false) ?? [];
      workingFieldNames = fields.map(item => item.GetFieldName());
    } else {
      const directoryFields = doc?.GetDirectoryColumns() ?? [];
      workingFieldNames = [...directoryFields];
    }

    const filteredFieldNames = filterInternalFields(workingFieldNames);
    return filteredFieldNames.sortBy(true, null, o => GetFieldLabelFromFieldName(o));
  })();

  return (
    <ColumnDisplayFieldToggleMenu
      selectedFieldNames={selectedFieldNames.sort()}
      fieldNames={fieldNames}
      onChange={ToggleField}
    />
  );
};

export default ColumnDisplayMenu;
